import { useTranslation } from "react-i18next";

import AccountSettings from "@/features/users/settings/components/AccountSettings";
import NotificationSettings from "@/features/users/settings/components/NotificationSettings";
import EmailSettings from "@/features/users/settings/components/EmailSettings";
import BaseTabs from "@/components_v2/Tabs/BaseTabs";

import "./styles.css";

const Settings = () => {
  const { t } = useTranslation();

  return (
    <div className="ms-5 w-50">
      <h1 className="header-l-medium mb-4">
        {t("users.labels.manageAccount")}
      </h1>
      <BaseTabs
        type="card"
        items={[
          {
            label: t("users.labels.account"),
            key: "account",
            children: <AccountSettings />,
          },
          {
            label: t("users.labels.notifications"),
            key: "notifications",
            children: <NotificationSettings />,
          },
          {
            label: t("users.labels.emailsTitle"),
            key: "emails",
            children: <EmailSettings />,
          },
        ]}
      />
    </div>
  );
};

export default Settings;
